import { AuthenticatedRoute } from "../routes/ProtectedRoutes.tsx";
import { PlaceProvider } from "../providers/PlaceProvider.tsx";
import { CampaignProvider } from "../views/Campaign/CampaignContext.tsx";
import { StatsProvider } from "../providers/StatsProvider.tsx";
import { ToDoProvider } from "../providers/ToDoProvider.tsx";
import Layout from "../views/Layout/Layout.tsx";
import SuspenseContainer from "../components/SuspenseContainer/SuspenseContainer.tsx";
import { Outlet } from "react-router-dom";

export const AppLayout = () => (
  <AuthenticatedRoute>
    <PlaceProvider>
      <CampaignProvider>
        <StatsProvider>
        <ToDoProvider>
          <Layout>
            <SuspenseContainer>
              <Outlet />
            </SuspenseContainer>
          </Layout>
        </ToDoProvider>
        </StatsProvider>
      </CampaignProvider>
    </PlaceProvider>
  </AuthenticatedRoute>
);
